import "./HomePage.scss";
import { Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";

import AwardLinkBlock from "../../Components/Block/AwardLinkBlock.js";
import makeStyles from '@mui/styles/makeStyles';
import Header from '../../Layouts/Header.js';
import Page from "../../Components/Page.js";
import { useAwards } from "../../Utils/Award.js";
import { useMemo } from "react";
import { generatePathMyList } from "../../Utils/Routes.js";
import { useScrollToTop } from "../../Utils/ScrollToTop";

const useStyles = makeStyles((theme) => ({
    awardList: {
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),

        [theme.breakpoints.up('sm')]: {
            paddingLeft: '10px',
            paddingRight: '10px',
        },
        [theme.breakpoints.up('md')]: {
            paddingLeft: '100px',
            paddingRight: '100px',
        },
    },
    awardsWrapper: {
        padding: theme.spacing(4),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(3)
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2)
        },
    },
    contentHeading: {
        textAlign: "center",
        marginTop: '2rem',
        '& .MuiTypography-overline': {
            color: theme.palette.secondary.light
        },
    }
}));

function HomePage() {
    const classes = useStyles();
    const user = useSelector(state => state.user.user);
    const awards = useAwards();

    const myListAsAward = useMemo(() => ({ 
        awardId: 'mylist', 
        title: "My list", 
        urlNextTo: generatePathMyList(),
        alwaysActive: true,
    }), []);

    const displayAwards = useMemo(() => [...(awards ?? []), myListAsAward], [awards, myListAsAward]);

    useScrollToTop();

    return (
        <Page>
            <div className="HomePage">
                <Header className="HomePage__header" />
                <div className={classes.contentHeading}>
                    <Typography variant="overline">WELCOME BACK {user?.firstName?.toUpperCase()}</Typography>
                    <Typography component="h3" variant="h3">YOUR CONTENT</Typography>
                </div>
                <Grid container className={classes.awardList} direction="row" justifyContent="center" alignItems="center">
                    {displayAwards?.length 
                        ? displayAwards.map((award) => (
                            <Grid 
                                key={award.awardId}
                                item xs={12} sm={6} md={6} lg={4} xl={3}
                                className={classes.awardsWrapper}
                            >
                                <AwardLinkBlock award={award} />
                            </Grid>
                        ))
                        : (
                            <Grid item className={classes.awardsWrapper}>
                                <Typography variant="h6">
                                    There are no entries to view currently. 
                                    Please look out for emails from membership which will alert you to when 
                                    Viewing and Voting rounds for the Awards are open.
                                </Typography>
                            </Grid>
                        )
                    }
                </Grid>
            </div>
        </Page>
    );
}
export default HomePage;